import React, { useState } from 'react';
import { Button, Modal, message } from 'antd';
import { useContext } from 'react';
import { SipPhoneContext } from '../SipPhoneProvider';
import { formatPhoneNumber } from '../../helpers/formatPhoneNumber';
import bindCallToRequest from '../../requests/bindCallToRequest';
import styles from './BindCallToRequest.module.scss';

const { confirm, info } = Modal;

const clickedConfirmBtns = {
  bind: 'bind',
  bindEnd: 'bindEnd',
};

const BindCallToRequest = ({ render, requestId, onSuccess }) => {
  const { call } = useContext(SipPhoneContext);

  const [isBindCallLoading, setIsBindCallLoading] = useState(false);
  const [clickedConfirmBtn, setClickedConfirmBtn] = useState('');

  const phoneNum = call.info?.phoneNumber
    ? formatPhoneNumber({
        phoneNumber: call.info.phoneNumber,
        format: '(xxx) xxx-xx-xx',
        placeholder: 'x',
      })
    : '';

  const handleCancel = (confirm) => {
    confirm.destroy();
    setClickedConfirmBtn('');
  };

  const handleOk = async (resetCallInfo = false) => {
    setIsBindCallLoading(true);

    const res = await bindCallToRequest({
      callId: call.info?.id || '',
      requestId,
    });

    if (res !== 'Error') {
      message.success('Звонок прикреплен');

      if (resetCallInfo) {
        call.setInfo(null);
      }

      if (typeof onSuccess === 'function') {
        await onSuccess();
        setIsBindCallLoading(false);
        return;
      }
    }

    setIsBindCallLoading(false);
    return res;
  };

  const handleClick = () => {
    const confirmModal = confirm({
      className: styles.confirmContainer,
      width: 600,
      title: `Прикрепить звонок по номеру ${phoneNum} к заявке № ${requestId}?`,
      okButtonProps: { className: styles.hide },
      cancelButtonProps: { className: styles.hide },
      content: (
        <div className={styles.confirmContent}>
          <Button
            disabled={isBindCallLoading}
            onClick={() => handleCancel(confirmModal)}
          >
            Отмена
          </Button>
          <Button
            disabled={isBindCallLoading}
            loading={
              isBindCallLoading && clickedConfirmBtn === clickedConfirmBtns.bind
            }
            type="primary"
            ghost
            onClick={async () => {
              setClickedConfirmBtn(clickedConfirmBtns.bind);
              await handleOk();
              confirmModal.destroy();
            }}
          >
            Прикрепить
          </Button>
          <Button
            type="primary"
            onClick={async () => {
              setClickedConfirmBtn(clickedConfirmBtns.bindEnd);
              await handleOk(true);
              confirmModal.destroy();
            }}
          >
            Прикрепить и завершить
          </Button>
        </div>
      ),
      onCancel: () => {
        setClickedConfirmBtn('');
      },
    });
  };

  return typeof render === 'function' ? render({ onClick: handleClick }) : null;
};

export default BindCallToRequest;
